import React, { useContext, useEffect, useState } from "react";
import { InputField } from "../../FormFields";
import { FormGrid, FormField } from "../../QueueIntegrationModal/panelKit";
import { AuthContext } from "../../../context/Auth/AuthContext";

export default function AddressForm(props) {

  const { user, socket } = useContext(AuthContext);

  const [billingName, setBillingName] = useState(user.company.name);
  const [addressZipCode, setAddressZipCode] = useState(user.company.document);
  const [addressStreet, setAddressStreet] = useState(user.company.addressStreet);
  const [addressState, setAddressState] = useState(user.company.addressState);
  const [addressCity, setAddressCity] = useState(user.company.addressCity);

  const {
    formField: {
      firstName,
      address1,
      city,
      state,
      zipcode,
      country,
    },
    setFieldValue
  } = props;
  useEffect(() => {
    setFieldValue("firstName", billingName)
    setFieldValue("zipcode", addressZipCode)
    setFieldValue("address2", addressStreet)
    setFieldValue("state", addressState)
    setFieldValue("city", addressCity)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FormGrid>
      <FormField label={firstName.label} htmlFor="checkout-firstName">
        <InputField
          id="checkout-firstName"
          name={firstName.name}
          variant="outlined"
          size="small"
          fullWidth
          value={billingName}
          onChange={(e) => {
            setBillingName(e.target.value)
            setFieldValue("firstName", e.target.value)
          }}
        />
      </FormField>

      <FormField label={zipcode.label} htmlFor="checkout-zipcode">
        <InputField
          id="checkout-zipcode"
          name={zipcode.name}
          variant="outlined"
          size="small"
          fullWidth
          value={addressZipCode}
          onChange={(e) => {
            setAddressZipCode(e.target.value)
            setFieldValue("zipcode", e.target.value)
          }}
        />
      </FormField>
    </FormGrid>
  );
}
